import WellReview from './WellReview';

export default WellReview;



// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/WellReview/index.tsx